import { autoinject } from 'aurelia-framework';
import { State } from '../../services/global-state';
import * as moment from 'moment';
import { PayrazrService } from '../../services/payrazr';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { Account } from '../../models/customer';
import { HpfPaymentPlanService } from '../../services/hpf-payment-plan.service';
import { ApiResponse } from '../../models/api-response';

@autoinject
export class SkipPlanPayments{
	isSubmitting = false;
	isLoading = true;
	maxPayments: number[] = [];
	selectedNumberOfPayments = null;
	reason = null;
	account: Account;
	validationErrors: string[] = [];
	plannedPayments;
	planEndDate;
	planId;
	planKey;
	isMAPP = false;

	constructor(
		private state: State,
		private payrazrService: PayrazrService,
		private hpfPaymentPlanService: HpfPaymentPlanService,
		private router: Router,
		private i18n: I18N
	) {}

	activate(params, data) {
		this.account = this.state.accounts.find((element, index, array) => {
			return element.id === data.accountId;
		});
		this.state.business.applyPortfolioSettingsToPortal(this.account.portfolioName, false);

		let portfolioPortalSettings = this.state.business.fetchPortfolioSettings(this.account.portfolioName).settings;
		if (!portfolioPortalSettings.paymentTypes.allowConsumersToSkipAPayment) {
			this.back();
		} else {
			const maxSkip: number = parseInt(portfolioPortalSettings.paymentTypes.maximumNumberOfPaymentsAConsumerCanSkip || 0, 10);
			this.getPlan().then(
				() => {
					this.getMaxPaymentsToSKip(maxSkip);
				},
				(errer) => {
					this.validationErrors = ['An Error Occured'];
				}
			);
		}
	}

	getPlan() {
		return this.payrazrService.getPaymentPlanByCustomerAccountId(this.account.id)
			.then(result => {
				if (result.endDate) {
					this.planEndDate = moment(result.endDate).format('MM/DD/YYYY');
				} else {
					this.planEndDate = 'Indefinite';
				}

				this.planId = result.id;
				this.planKey = result.key;
				this.isMAPP = result.isCombinedCustomerAccount;

				// Get list of payments
				return this.payrazrService.getLatestActivePaymentPlanPlannedPaymentsByCustomerAccountId(this.account.id)
					.then(results => {
						this.plannedPayments = results.plannedPayments.length;
						this.isLoading = false;
					})
					.catch(error => {
						console.error(error);
				this.isLoading = false;
					});
			})
			.catch(error => {
				console.error(error);
				this.isLoading = false;
			});
	}

	getMaxPaymentsToSKip(max: number) {
		if (this.planEndDate !== 'Indefinite') {
			max = max < this.plannedPayments ? max : this.plannedPayments;
		}
		this.maxPayments = Array.from(Array(max), (_, i) => i + 1);
	}

	back() {
		this.router.navigateBack();
	}

	submit() {
		this.isSubmitting = true;
		this.validationErrors = [];

		if(this.isMAPP) {
			this.validationErrors.push(this.i18n.i18next.t('cannotSkipMultiAccountPaymentPlans', 'Cannot skip payments plans with multi accounts'));
			this.isSubmitting = false;
			return;
		};

		if (!this.reason) {
			this.validationErrors.push(this.i18n.i18next.t('reasonIsRequired', 'Reason is required'));
			this.isSubmitting = false;
			return;
		}

		this.hpfPaymentPlanService.skipPlanPayments(this.planKey, this.selectedNumberOfPayments, this.reason).then(
			(result: ApiResponse) => {
				if (result.isSuccessful) {
					this.isSubmitting = false;
					this.back();
				} else {
					this.isSubmitting = false;
					alert(result.errors[0]);
				}
			},
			(error) => {
				this.isSubmitting = false;
			}
		);
	}
}
